import React, { JSX, ReactElement } from "react";

import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    PropTypes,
    Theme,
    Stack,
    IconButtonProps,
    Icon,
    SvgIconTypeMap
} from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import CloseIcon from '@mui/icons-material/Close';
import { OverridableComponent } from "@mui/material/OverridableComponent";

type Color = PropTypes.Color | 'transparent';

interface ToolbarCadProps {
    title: string;
    subtitle?: string;
    color?: Color;
    variantToobar?: "dense" | "regular";
    positionToolBar?: "relative" | "fixed" | "absolute" | "sticky" | "static",
    handleBack?: () => void;
    elevation: number;
    buttonNovo: {
        show: boolean,
        onClick: () => void;
        title: string;
    }
    buttonEnd?:{
        onClick: ()=> void;
        title:string,
        Icon:()=>JSX.Element
    }
}


const useStyles = makeStyles()((theme: Theme) => ({
    title: {
        flex: 1,
        marginLeft: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            fontSize: '90%',
        }
    },
}));


export function ToolbarCad(props: ToolbarCadProps) {
    const { classes } = useStyles()
    const {
        title,
        subtitle,
        color,
        variantToobar,
        positionToolBar,
        handleBack,
        buttonNovo,
        elevation,
        buttonEnd
    } = props;

    return (
        <AppBar elevation={elevation} position={positionToolBar ? positionToolBar : "relative"} color={color} >
            <Toolbar variant={variantToobar} >

                {handleBack && (
                    <IconButton
                        title={"Voltar"}
                        onClick={handleBack}
                        color="inherit"
                        edge="start"
                        size="large"
                    >
                        <ArrowBackIosNewIcon />
                    </IconButton>
                )}
                {subtitle ? (
                    <Stack flex={1} flexDirection={"column"}>
                        <Typography
                            noWrap
                            variant="h6"
                            component={"span"}
                            className={classes.title}
                        >
                            {title}
                        </Typography>
                        <Typography
                            noWrap
                            variant="caption"
                            component={"span"}
                            className={classes.title}
                        >
                            {subtitle}
                        </Typography>
                    </Stack>

                ) : (
                    <Typography
                        noWrap
                        variant="h6"
                        component={"span"}
                        className={classes.title}
                    >
                        {title}
                    </Typography>

                )}
                {buttonNovo.show && (
                    <IconButton
                        title={buttonNovo.title}
                        onClick={buttonNovo.onClick}
                        color="inherit"
                        edge="end"
                    >
                        <ControlPointIcon />
                    </IconButton>
                )}
                {buttonEnd&&(
                    <IconButton 
                        title={buttonEnd.title}
                        onClick={buttonEnd.onClick}
                    >
                        <buttonEnd.Icon/>
                    </IconButton>
                )}                

            </Toolbar>
        </AppBar>
    );
}


export function ToolbarList(props: ToolbarCadProps) {
    const { classes } = useStyles()
    const {
        title,
        color,
        variantToobar,
        positionToolBar,
        handleBack,
        buttonNovo,
        elevation,
        buttonEnd
    } = props;

    return (
        <AppBar elevation={elevation} position={positionToolBar ? positionToolBar : "relative"} color={color} >
            <Toolbar variant={variantToobar} >

                {buttonNovo.show && (
                    <IconButton
                        title={buttonNovo.title}
                        onClick={buttonNovo.onClick}
                        color="inherit"
                        edge="end"
                    >
                        <ControlPointIcon />
                    </IconButton>
                )}

                <Typography
                    noWrap
                    variant="h6"
                    component={"span"}
                    className={classes.title}
                >
                    {title}
                </Typography>

                {buttonEnd&&(
                    <IconButton 
                        title={buttonEnd.title}
                        onClick={buttonEnd.onClick}
                    >
                        <buttonEnd.Icon/>
                    </IconButton>
                )}
            </Toolbar>
        </AppBar>
    );
}


interface ToolbarModalProps {
    title: string;
    color?: Color;
    variantToobar?: "dense" | "regular";
    positionToolBar?: "relative" | "fixed" | "absolute" | "sticky" | "static",
    handleClose: () => void;
    elevation: number
    iconButtonStart?: {
        Icon: JSX.Element,
        title: string,
        onClick: () => any
    }

}


export function ToolbarModal(props: ToolbarModalProps) {
    const { classes } = useStyles()
    const {
        title,
        color,
        variantToobar,
        positionToolBar,
        handleClose,
        elevation,
        iconButtonStart
    } = props;

    return (
        <AppBar elevation={elevation} position={positionToolBar ? positionToolBar : "relative"} color={color} >
            <Toolbar variant={variantToobar} >
                {iconButtonStart && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        title={iconButtonStart.title}
                        onClick={iconButtonStart.onClick}
                        sx={{ mr: 2 }}
                    >
                        {iconButtonStart.Icon}
                    </IconButton>

                )}
                <Typography
                    noWrap
                    variant="h6"
                    component={"span"}

                    className={classes.title}
                >
                    {title}
                </Typography>
                <IconButton
                    title={"Fechar"}
                    onClick={handleClose}
                    color="inherit"
                    edge="end"
                >
                    <CloseIcon />
                </IconButton>

            </Toolbar>
        </AppBar>
    );
}
